/* HAR_SYNC_EMAIL — the single RWB bridge account every HAR-sync surface
 * (renderer UI gate + main-process IPC gate) checks against. Lives here,
 * not in a renderer service, so both processes import the SAME constant
 * instead of two copies drifting apart. */
export const HAR_SYNC_EMAIL = 'jbeardsley@rwb.net';
